import React from "react";
import { Link } from "react-router-dom";
import { Form } from "reactstrap";

class InstagramAuth extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.location.search === "") {
            return (
                <section className="gray-bg full-height">
                    <div className="container py-5">
                        <div className="col-12">
                            <Form>
                                <div className="row mx-0 my-0">
                                    Connecting to Instagram ...
                                </div>
                            </Form>
                        </div>
                    </div>
                </section>
            );

        }
        // --- POST THE CODE BACK AND CLOSE POPUP IF IT EXISTS ---
        const searchParams = new URLSearchParams(this.props.location.search);
        const code = searchParams.get("code");

        if (code) {
            // Send the code to the parent window (if it exists)
            const channel = new BroadcastChannel('authCode');
            channel.postMessage(code);
            channel.close();
            window.close();
        }

        return (
            <section className="gray-bg full-height">
                <div className="container py-5">
                    <div className="col-12">
                        <Form>
                            <div className="row mx-0 my-0">
                                You have successfully connected your Instagram account!
                            </div>
                            <div className="row mx-0 my-0">
                                <div class="form-group">
                                    <Link to="/"><button type="submit" class="btn btn-primary">Next</button></Link>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </section>
        );
    }
}

export default InstagramAuth;